var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotionTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_59938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9129 138.697C94.9687 148.46 90.1853 157.888 85.4154 167.329C82.682 172.747 77.0947 175.778 71.5744 174.825C65.3573 173.753 61.0831 169.327 60.2925 163.078C59.971 160.57 60.5069 158.209 61.5788 155.943C67.0053 144.53 72.4453 133.118 77.8182 121.678C78.247 120.766 78.5015 119.667 78.5149 118.661C78.5685 108.965 78.5417 99.2554 78.5417 89.2912C77.8986 89.2912 77.3225 89.2912 76.7329 89.2912C70.3819 89.2912 64.0308 89.2912 57.6798 89.2912C51.2349 89.2778 46.4247 84.6779 46.4515 78.5491C46.4649 72.4338 51.2617 67.8875 57.7601 67.8875C70.0737 67.8875 82.3872 67.8875 94.7141 67.8875C95.3707 67.8875 96.0272 67.8875 96.6838 67.8875C82.2398 64.6689 77.443 52.3846 78.7293 43.8017C80.4176 32.483 89.5154 24.7717 100.744 25.0534C111.315 25.3216 120.239 33.7436 121.271 44.5527C122.195 54.3426 116.032 65.2054 103.249 67.8741C103.879 67.8741 104.495 67.8741 105.125 67.8741C117.666 67.8741 130.208 67.8339 142.749 67.9009C147.291 67.9277 150.654 70.1137 152.517 74.2711C154.312 78.3077 153.682 82.1432 150.869 85.5227C148.765 88.0708 145.938 89.2778 142.628 89.2778C136.224 89.2912 129.806 89.2778 123.401 89.2778C122.798 89.2778 122.195 89.2778 121.351 89.2778V91.1419C121.351 100.288 121.324 109.434 121.378 118.58C121.378 119.6 121.619 120.686 122.048 121.611C127.394 132.997 132.807 144.356 138.207 155.728C141.463 162.581 138.917 170.333 132.365 173.565C125.665 176.864 117.975 174.195 114.518 167.369C109.989 158.424 105.46 149.479 100.931 140.547C100.663 140.011 100.355 139.501 99.9129 138.697Z",
    fill: "url(#paint0_linear_121_59938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 116.194C174.759 123.637 172.092 130.128 167.537 135.868C165.982 137.826 164.254 139.663 162.432 141.366C160.194 143.472 156.965 143.284 154.942 141.138C152.919 138.992 153.079 135.908 155.116 133.601C157.313 131.107 159.672 128.653 161.373 125.823C165.259 119.372 165.219 112.627 161.32 106.176C159.725 103.534 157.595 101.187 155.505 98.9075C153.106 96.279 152.811 93.1542 155.049 90.8878C157.246 88.6616 160.422 88.7689 162.928 91.156C168.622 96.574 172.869 102.864 174.357 110.722C174.692 112.519 174.812 114.357 175.027 116.181L175 116.194Z",
    fill: "url(#paint1_linear_121_59938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 116.81C25.1876 107.141 28.8723 99.832 34.7142 93.4753C35.6119 92.4963 36.5632 91.5307 37.5681 90.659C39.7923 88.7144 42.9544 88.8754 44.9509 90.954C46.9473 93.0327 46.9071 96.1574 44.9509 98.3702C43.0348 100.529 40.9312 102.581 39.3502 104.968C34.4864 112.317 34.5132 119.841 39.3636 127.19C40.7972 129.349 42.6061 131.294 44.4015 133.185C46.8535 135.773 47.1349 138.938 44.9241 141.204C42.7133 143.484 39.5109 143.364 36.925 140.869C31.2841 135.478 27.0768 129.229 25.5895 121.423C25.2412 119.626 25.134 117.789 25.0134 116.797L25 116.81Z",
    fill: "url(#paint2_linear_121_59938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9544 35.5139C45.3796 37.901 47.6574 40.1004 49.895 42.3534C52.3068 44.7807 52.414 48.0262 50.2166 50.2255C48.0058 52.4249 44.7766 52.3176 42.3515 49.9037C40.1005 47.6641 37.8896 45.3842 35.5448 42.9971C35.1831 43.5067 34.9285 43.8956 34.6471 44.2711C33.3206 46.0548 31.0696 46.8326 29.0196 46.2425C26.8222 45.6122 25.1607 43.7883 25.1072 41.5621C24.9866 37.673 24.9598 33.7705 25.0938 29.8679C25.2009 27.1321 27.5323 25.0937 30.3595 25.0534C33.8164 24.9998 37.2599 25.0266 40.7168 25.0534C43.5038 25.0534 45.527 26.5286 46.2371 29.0096C46.8937 31.3029 45.9691 33.5022 43.7181 35.0043C43.544 35.125 43.3698 35.2457 42.9544 35.5139Z",
    fill: "url(#paint3_linear_121_59938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.415 42.9842C161.976 45.4518 159.672 47.8658 157.273 50.1724C154.165 53.1496 149.301 51.8219 148.283 47.7451C147.774 45.7468 148.35 44.0034 149.81 42.5551C152.128 40.235 154.46 37.9283 156.885 35.5144C156.376 35.1523 155.974 34.8975 155.585 34.6025C153.816 33.248 153.066 31.0352 153.682 28.9565C154.326 26.7571 156.134 25.1344 158.399 25.0808C162.244 24.9869 166.09 24.9601 169.922 25.0808C172.722 25.1612 174.812 27.5215 174.853 30.4183C174.906 33.9319 174.893 37.4456 174.853 40.9458C174.826 43.5475 173.365 45.492 171.007 46.2028C168.689 46.9136 166.465 46.0285 164.964 43.8157C164.817 43.6011 164.669 43.3731 164.415 42.9842Z",
    fill: "url(#paint4_linear_121_59938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9277 164.512C45.4869 165.934 46.7598 167.825 46.3444 170.534C45.9692 172.975 43.8522 174.879 41.3734 174.933C37.6486 175.013 33.9103 175.027 30.1854 174.933C27.2913 174.866 25.0938 172.559 25.0536 169.609C25.0001 166.149 25.0269 162.702 25.0536 159.242C25.067 156.426 26.5275 154.441 29.0197 153.73C31.3109 153.086 33.5083 154.012 35.009 156.265C35.1296 156.439 35.2502 156.614 35.5315 157.029C37.9835 154.535 40.2881 152.054 42.7267 149.734C45.8085 146.783 50.7258 148.272 51.6637 152.362C52.1193 154.374 51.4896 156.09 50.0291 157.525C47.7245 159.792 45.4333 162.058 42.9545 164.499L42.9277 164.512Z",
    fill: "url(#paint5_linear_121_59938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.402 157.07C165.929 154.428 167.885 153.087 170.739 153.717C173.111 154.241 174.799 156.306 174.839 158.773C174.906 162.394 174.906 166.015 174.839 169.636C174.786 172.734 172.508 174.933 169.359 174.96C165.969 175 162.566 174.987 159.163 174.96C156.376 174.947 154.352 173.472 153.642 171.004C152.986 168.697 153.91 166.511 156.161 165.009C156.336 164.889 156.51 164.768 156.938 164.5C154.446 162.046 151.981 159.739 149.663 157.298C146.715 154.214 148.176 149.279 152.262 148.353C154.272 147.897 155.987 148.527 157.434 149.976C158.573 151.129 159.725 152.256 160.851 153.409C161.976 154.562 163.089 155.729 164.388 157.084L164.402 157.07Z",
    fill: "url(#paint6_linear_121_59938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0652 116.019C41.226 109.863 44.0531 104.968 48.6623 101.052C50.7123 99.3224 53.7807 99.7113 55.6431 101.656C57.5458 103.641 57.6396 106.685 55.8575 108.804C55.134 109.649 54.3032 110.4 53.6333 111.285C51.1947 114.503 51.1947 117.561 53.6065 120.793C54.2764 121.678 55.1072 122.429 55.8307 123.274C57.6396 125.393 57.5592 128.437 55.6699 130.435C53.7673 132.447 50.6722 132.796 48.5551 130.972C44.0129 127.069 41.2126 122.228 41.0652 116.019Z",
    fill: "url(#paint7_linear_121_59938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.801 117.025C158.68 122.201 155.88 127.11 151.257 131.026C149.127 132.823 146.032 132.42 144.156 130.382C142.293 128.357 142.267 125.326 144.102 123.22C144.839 122.389 145.657 121.625 146.326 120.739C148.644 117.642 148.685 114.638 146.393 111.513C145.71 110.574 144.839 109.769 144.075 108.884C142.253 106.779 142.293 103.748 144.169 101.723C146.045 99.6979 149.087 99.4297 151.297 101.079C155.612 104.311 158.761 110.601 158.787 117.025H158.801Z",
    fill: "url(#paint8_linear_121_59938)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_59938",
    x1: 99.9888,
    y1: 25.0459,
    x2: 99.9888,
    y2: 174.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_59938",
    x1: 164.265,
    y1: 89.2891,
    x2: 164.265,
    y2: 142.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_59938",
    x1: 35.7166,
    y1: 89.293,
    x2: 35.7166,
    y2: 142.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_59938",
    x1: 38.3962,
    y1: 25.0225,
    x2: 38.3962,
    y2: 51.7983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_59938",
    x1: 161.494,
    y1: 25,
    x2: 161.494,
    y2: 51.7879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_59938",
    x1: 38.4162,
    y1: 148.188,
    x2: 38.4162,
    y2: 174.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_121_59938",
    x1: 161.5,
    y1: 148.207,
    x2: 161.5,
    y2: 174.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_121_59938",
    x1: 49.1019,
    y1: 99.9512,
    x2: 49.1019,
    y2: 132.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_121_59938",
    x1: 150.768,
    y1: 100.002,
    x2: 150.768,
    y2: 132.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_59938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionTracking);
export default __webpack_public_path__ + "static/media/Motion_Tracking.95b6427dd1452ce3919ce73d1889ca0e.svg";
export { ForwardRef as ReactComponent };